
const DefaultRequestConst = {
    asc: false,
    limit: 50,
    page: 0,
    reconversion: '',
    search:'',
    shipmentStatus:'',
    sort: 'date',
    status: '',
};

export default DefaultRequestConst;